import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { RegexValidatorPatternService } from '../../../services/regex-validator-pattern.service';

import { ValidatorEditorBase } from '../validator-editor-base/validator-editor-base';
import { RegexValidatorModel } from '../../../types/validator.types';

@Component({
  selector: 'df-regex-validator-editor',
  templateUrl: './regex-validator-editor.component.html',
  styleUrls: ['./regex-validator-editor.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegexValidatorEditorComponent extends ValidatorEditorBase<RegexValidatorModel> implements OnInit {
  set regexName(name: string) {
    this._regexName = name;
    this.model.data = this.getValidatorModelByRegexName(name);
    this.emitModelChange();
  }

  get regexName(): string {
    return this._regexName;
  }

  customRegexName = 'custom';
  regexModel: RegexValidatorModel[];

  private _regexName: string;

  constructor(private regexService: RegexValidatorPatternService) {
    super();
    this.regexModel = this.regexService.getValidatorModels();
  }

  ngOnInit() {
    if (!this.caption) {
      this.caption = 'æ­£åè¡¨è¾¾å¼';
    }
  }

  afterModelInit() {
    const customRegex = this.getValidatorModelByRegexName(this.customRegexName);
    if (!this.data) {
      return;
    }
    // éæ°èµå¼èªå®ä¹è¡¨åå¼çå¼åæç¤ºä¿¡æ¯
    if (this.data.name === this.customRegexName) {
      customRegex.errorMessage = this.data.errorMessage;
      customRegex.expression = this.data.expression;
    }
    this._regexName = this.data.name;
    return;
  }

  defaultModelData(): RegexValidatorModel {
    return undefined;
  }

  private getValidatorModelByRegexName(name: string): RegexValidatorModel {
    return this.regexModel.find((s) => s.name === name);
  }
}
